<template>
    <div class="loading-challenge-practice">
        <Preloader preloaderText="Çıkış yapılıyor..."/>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import Preloader from '@/components/Preloader.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            Preloader,
        }
    };
</script>

<style scoped src="@/css/components/loading-challenge-practice.css"></style>